import { Component, computed, inject, input, resource, signal } from '@angular/core';
import { SwitchBarOption, SwitchBar } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { Api } from '../../../../core/clients/omni-core/api';
import { getEnergyCostByYear } from '../../../../core/clients/omni-core/functions';
import { form, FormField } from '@angular/forms/signals';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { ResponsiveValue } from '../../../../shared/components/responsive-value/responsive-value';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { TranslocoPipe } from '@jsverse/transloco';
import { DashboardSummaryCardSkeleton } from '../dashboard-summary-card-skeleton/dashboard-summary-card-skeleton';

@Component({
  selector: 'app-dashboard-cost-summary-card',
  imports: [
    SwitchBarOption,
    NgIcon,
    SwitchBar,
    FormField,
    GermanNumberPipe,
    ResponsiveValue,
    ErrorComponent,
    TranslocoPipe,
    DashboardSummaryCardSkeleton,
  ],
  templateUrl: './dashboard-cost-summary-card.html',
})
export class DashboardCostSummaryCard {
  private api = inject(Api);

  organizationId = input.required<string>();
  year = input.required<number>();

  protected cost = resource({
    params: () => ({
      id: this.organizationId(),
      year: this.year(),
    }),
    loader: async ({ params }) => this.api.invoke(getEnergyCostByYear, params),
  });

  private settings = signal<{ utilityType: 'ELECTRICITY' | 'GAS' }>({
    utilityType: 'ELECTRICITY',
  });
  protected settingsForm = form(this.settings);

  protected costValue = computed(() => {
    const value = this.cost.hasValue() ? this.cost.value() : null;
    switch (this.settings().utilityType) {
      case 'ELECTRICITY':
        return value?.electricity ?? { min: 0, max: 0 };
      case 'GAS':
        return value?.gas ?? { min: 0, max: 0 };
    }
  });
}
